import {
    StyledIconButton,
    CardsContainer,
    Container,
    Title,
    TitleContainer,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/HowItWorksSection/HowItWorksSection.styled";
import { memo, useState } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import InfoCard from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/HowItWorksSection/InfoCard/InfoCard";
import { howItWorksData } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/HowItWorksSection/consts";
import { allTrackers } from "app/services/track/track";
import { EVENTS_CATEGORY } from "app/pages/digital-suite/home-page/components/Rewards/utils/consts";

const HowItWorksSection = memo(() => {
    const i18n = i18nFilter();
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        allTrackers.trackEvent(EVENTS_CATEGORY, isOpen ? "close" : "open", "How it works");
        setIsOpen((prev) => !prev);
    };

    return (
        <Container data-automation="how-it-works-section">
            <TitleContainer onClick={handleClick}>
                <Title>{i18n("rewards_modal.main_screen.how_it_works.title")}</Title>
                <StyledIconButton
                    iconSize="sm"
                    type="flat"
                    iconName={isOpen ? "chev-down" : "chev-up"}
                />
            </TitleContainer>
            <CardsContainer
                isOpen={isOpen}
                data-automation="cards-container"
            >
                {howItWorksData.map(({ title, subtitle }, index) => (
                    <InfoCard
                        key={index}
                        cardIndex={index + 1}
                        title={title}
                        subtitle={subtitle}
                    />
                ))}
            </CardsContainer>
        </Container>
    );
});

export default HowItWorksSection;
